import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";

export default function AdminTags() {
  const [tags, setTags] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/tags").then(({ data }) => setTags(data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/tags", { name });
      setName("");
      load();
    } catch (err) {
      toast.error(apiErrorMessage(err));
    }
  };

  const remove = async (id) => {
    await api.delete(`/tags/${id}`);
    load();
  };

  return (
    <div data-testid="admin-tags-page">
      <h1 className="font-serif text-3xl font-bold text-[#1A1A1A] mb-8">Тагове</h1>
      <form onSubmit={create} className="flex gap-3 mb-8 max-w-md">
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Нов таг" data-testid="admin-tag-name-input" />
        <Button type="submit" className="bg-[#A6192E] hover:bg-[#8C1123]" data-testid="admin-tag-create-btn">Добави</Button>
      </form>
      <div className="flex flex-wrap gap-2" data-testid="admin-tags-list">
        {tags.map((t) => (
          <span key={t.id} className="inline-flex items-center gap-2 bg-white border border-[#E2E8F0] px-3 py-1.5 text-sm" data-testid={`admin-tag-${t.slug}`}>
            {t.name}
            <button onClick={() => remove(t.id)} data-testid={`admin-tag-delete-${t.slug}`}><X className="w-3.5 h-3.5 text-[#718096] hover:text-red-600" /></button>
          </span>
        ))}
      </div>
    </div>
  );
}
